export default {
	project: {
		my_xs: 'Mis decisiones',
		fields: {
			name: 'Título',
			name_explanation: 'Proporciona un título para tu proyecto',
			description: 'Misión',
			description_explanation: 'Establece tu misión general',
			vision: 'Visión',
			vision_explanation: 'Expresa la visión a largo plazo del proyecto',
			description_long: 'Descripción',
			description_long_explanation: 'Ej.: «PYME suiza de mecatrónica, 200 personas, mercado europeo de OEM automotor. Misión: convertirse en el líder europeo de sensores inteligentes para 2030.»',
			description_long_hint: 'Cuanto más precisa sea la descripción (sector, tamaño, misión), más exacto será el análisis.',
			description_long_warning_title: 'Descripción breve',
			description_long_warning_body: 'Tu descripción tiene {{count}} caracteres. La IA puede inferir un sector o contexto que no coincide con tu organización. ¿Deseas enriquecerla antes de lanzar?',
			description_long_warning_enrich: 'Enriquecer',
			description_long_warning_continue: 'Lanzar de todos modos',
			ai_context: 'Enfoque y ángulos específicos',
			ai_context_explanation: 'Indica los ángulos, actores o restricciones que el análisis debe priorizar (p. ej. un competidor concreto, una dimensión regulatoria, un territorio, una restricción temporal…).',
			fishbone_description: 'Plan estratégico - A ser',
			fishbone_description_explanation: '',
			reference: 'Referencia',
			tags: 'Etiquetas',
			likelihoods: 'Probabilidades',
			impacts: 'Impactos',
			types: {
				stakeholders: 'Partes interesadas',
				stakeholders_long: 'Proyecto de partes interesadas',
				stakeholders_explanation: 'Alinea las fuerzas presentes',
				risks: 'Riesgos',
				risks_long: 'Proyecto de riesgos',
				risks_explanation: 'Convierte tus riesgos en aperturas',
				pro: 'Ejecución de estrategia',
				pro_long: 'Proyecto de ejecución de estrategia',
				pro_explanation: 'Implementa con agilidad'
			},
			ai: {
				scenarios: {
					title: "Escenarios a explorar",
					hint: "Procesados por la IA privada — sin envío de datos al exterior. Puedes modificar el texto, el horizonte temporal, añadir o quitar escenarios.",
					worst_label: "Peor caso",
					worst_default: "Los riesgos mayores se materializan, las oportunidades se pierden, las partes interesadas se oponen.",
					best_label: "Mejor caso",
					best_default: "Los riesgos se gestionan, las oportunidades se aprovechan, las partes interesadas cooperan.",
					add: "Añadir un escenario",
					remove: "Eliminar este escenario",
					label_placeholder: "Nombre del escenario",
					content_placeholder: "Hipótesis, eventos clave, condiciones de realización…"
				},
				horizon_unit: {
					d: "días",
					w: "semanas",
					m: "meses",
					y: "años"
				}
			},
		},
		messages: {
			delete_confirmation: 'Eliminar proyecto',
			delete_confirmation_explanation:
				'¿Estás seguro de que quieres eliminar el proyecto "{{name}}"? Esta acción no se puede deshacer.',
			clone_confirmation: 'Clonar proyecto',
			clone_confirmation_explanation:
				'¿Estás seguro de que quieres clonar este proyecto?',
			clone_in_progress:
				'Estamos clonando tu proyecto, por favor espera...',
			delete_in_progress:
				'Estamos eliminando tu proyecto, por favor espera...'
		},
		actions: {
			edit: 'Editar detalles del proyecto',
			delete: 'Eliminar proyecto',
			clone: 'Clonar proyecto',
			open: 'Abrir proyecto'
		}
	},
	option: {
		fields: {
			name_explanation: 'Por favor ingresa un nombre para esta opción'
		}
	},
	item: {
		name: 'Parte interesada',
		name_plural: 'Partes interesadas',
		activeness_zones: {
			external_outer_positive: 'Neutral',
			external_inner_positive: 'Inactivo',
			external_outer_negative: 'Neutral',
			external_inner_negative: 'Inactivo',

			internal_low_positive: 'Bajo',
			internal_medium_positive: 'Medio',
			internal_high_positive: 'Alto',
			internal_low_negative: 'Bajo',
			internal_medium_negative: 'Medio',
			internal_high_negative: 'Alto',

			internal_positive: 'Catalizadores',
			internal_negative: 'Inhibidores'
		},
		messages: {
			delete_confirmation: 'Eliminar parte interesada',
			delete_confirmation_explanation:
				'¿Estás seguro de que quieres eliminar esta parte interesada? Esta acción no se puede deshacer y afectará a todos los escenarios.\n\nSi solo quieres ocultar la parte interesada para este escenario, cierra esta ventana, selecciónala y en la columna derecha, haz clic en el botón "ojo" para desactivarla en este escenario.'
		},
		fields: {
			name: 'Nombre',
			description: 'Descripción',
			links: {
				outcoming: {
					name: 'Enlaces salientes'
				},
				incoming: {
					name: 'Enlaces entrantes'
				}
			},
			stakes: {
				name: 'Relaciones de intereses'
			},
			indicators: {
				name: 'Relaciones de indicadores'
			},
			risks: {
				name: 'Relaciones de riesgos'
			},
			opportunities: {
				name: 'Relaciones de aperturas'
			},
			impact: {
				label: 'Importancia',
				level: {
					low: 'Bajo',
					medium: 'Medio',
					high: 'Alto'
				}
			},
			trend: {
				label: 'Tonalidad',
				level: {
					green: 'Positivo',
					neutral: 'Neutral',
					orange: 'En riesgo',
					red: 'Negativo'
				}
			}
		},
		actions: {
			create_new: 'Crear parte interesada',
			edit: 'Editar detalles',
			delete: 'Eliminar parte interesada',
			clone: 'Clonar parte interesada'
		},
		no_x: 'Sin parte interesada',
		engagement: 'Compromiso',
		importance: 'Importancia',
		trust: 'Tonalidad',
		levels: {
			low: 'Bajo',
			medium: 'Medio',
			high: 'Alto',
			inactive_neutral: 'Inactivo / Neutral',
			positive: 'Positivo',
			positive_short: 'Pos.',
			negative: 'Negativo',
			negative_short: 'Neg.',
			at_risk: 'En riesgo',
			neutral: 'Neutral'
		}
	},
	item_link: {
		no_x: 'Sin enlace',
		actions: {
			create_new: 'Crear nuevo enlace'
		}
	},
	item_comment: {
		no_x: 'Sin historial',
		actions: {
			create_new: 'Crear nuevo historial'
		}
	},
	tag: {
		name: 'Etiqueta',
		name_plural: 'Etiquetas',
		fields: {
			name: 'Etiqueta',
			name_plural: 'Etiquetas'
		},
		messages: {
			delete_confirmation: 'Eliminar etiqueta',
			delete_confirmation_explanation:
				'¿Estás seguro de que quieres eliminar esta etiqueta? Esta acción no se puede deshacer.',
			no_x: 'Sin etiqueta'
		},
		actions: {
			add_x: 'Agregar una etiqueta',
			create_new: 'Crear una etiqueta',
			edit: 'Editar etiqueta',
			delete: 'Eliminar etiqueta'
		}
	},
	stake: {
		no_x: 'Sin interés',
		name: 'Interés',
		name_plural: 'Intereses',
		fields: {
			name: 'Nombre',
			reference: 'Referencia',
			name_plural: 'Intereses',
			description: 'Descripción',
			evaluated_at: 'Evaluación',
			weight: 'Peso',
			trend: 'Estado',
			risks: {
				name: 'Relaciones de riesgos',
				name_positive: 'Relaciones de aperturas'
			},
			trend_tier: {
				strained: 'Precario',
				mixed: 'Mixto',
				solid: 'Sólido'
			}
		},
		actions: {
			delete: 'Eliminar interés',
			edit: 'Editar interés',
			create_new: 'Crear interés'
		},
		message: {
			no_x: 'Sin interés'
		},
		messages: {
			delete_confirmation: 'Eliminar interés',
			delete_confirmation_explanation:
				'¿Estás seguro de que quieres eliminar este interés? Esta acción no se puede deshacer y afectará a todos los escenarios.\n\nSi solo quieres ocultar el interés para este escenario, cierra esta ventana, selecciónalo y en la columna derecha, haz clic en el botón "ojo" para desactivarlo en este escenario.'
		}
	},

	indicator: {
		name: 'Indicador',
		name_plural: 'Indicadores',
		no_x: 'Sin indicador',
		fields: {
			indicator_category: 'Categoría',
			name: 'Nombre',
			reference: 'Referencia',
			name_plural: 'Indicadores',
			evaluated_at: 'Última evaluación',
			frequency: 'Frecuencia',
			weight: 'Peso',
			description: 'Descripción'
		},
		action: {
			add_x: 'Agregar un punto de indicador'
		},
		message: {
			no_x: 'Sin indicador'
		},
		messages: {
			delete_confirmation: 'Eliminar indicador',
			delete_confirmation_explanation:
				'¿Estás seguro de que quieres eliminar este indicador? Esta acción no se puede deshacer y afectará a todos los escenarios.\n\nSi solo quieres ocultar el indicador para este escenario, cierra esta ventana, selecciónalo y en la columna derecha, haz clic en el botón "ojo" para desactivarlo en este escenario.'
		},
		actions: {
			delete: 'Eliminar indicador',
			edit: 'Editar indicador',
			create_new: 'Crear indicador'
		}
	},

	scenario: {
		name: 'Escenario',
		name_plural: 'Escenarios',
		no_x: 'Sin escenario',
		baseline: 'Línea base',
		fields: {
			name: 'Nombre',
			name_long: 'Nombre del escenario',
			score: 'Puntuación del escenario',
			description: 'Descripción',
			impacts: 'Descripción de impactos',
			generate_simulation: 'Generar simulación automáticamente',
			simulation_query: 'Hipótesis y horizonte temporal'
		},
		placeholders: {
			simulation_query:
				'Ej.: ¿Qué pasaría si el precio del petróleo aumentara un 50% en 2 años? ¿Qué consecuencias tendría sobre las partes interesadas y los riesgos identificados?'
		},
		messages: {
			delete_confirmation: 'Eliminar escenario',
			delete_confirmation_explanation:
				'¿Estás seguro de que quieres eliminar este escenario? Esta acción no se puede deshacer.',
			creation_in_progress:
				'Por favor espere mientras se prepara su escenario...',
			switch_scenario: 'Cambiar a línea base u otro escenario',
			simulation_explanation:
				'La IA analizará tu hipótesis y propondrá modificaciones a las partes interesadas, riesgos y retos del proyecto para simular este escenario.',

			promote_as_baseline: {
				title: 'Promover este escenario como la nueva línea base',
				explanation:
					'¿Estás seguro de que quieres promover el escenario "<0>{{name}}</0>" como la nueva línea base? Esta acción no se puede deshacer.',
				keep_current_baseline_as_scenario_question:
					'¿Qué te gustaría hacer con la línea base anterior?',
				keep_current_baseline_as_scenario_question_yes:
					'Quiero mantenerla y darle el siguiente nombre',
				keep_current_baseline_as_scenario_question_no:
					'Nada, puede ser eliminada',
				keep_scenario_question:
					'¿Te gustaría mantener una copia del escenario ahora promovido como la nueva línea base?',
				keep_scenario_question_yes: 'Sí, mantener una copia',
				keep_scenario_question_no: 'No, no necesito una copia',
				loading: 'Promoción del escenario en curso...'
			},

			best_evaluation: 'Mejor caso entre todos los escenarios'
		},
		actions: {
			create_new: 'Crear un nuevo escenario',
			create_new_from_baseline:
				'Crear un nuevo escenario desde la línea base',
			save_as_new_baseline: 'Guardar como nueva línea base',
			clone: 'Clonar escenario',
			edit: 'Editar escenario',
			delete: 'Eliminar escenario',
			next: 'Ir al siguiente escenario',
			previous: 'Ir al escenario anterior',
			previous_baseline: 'Ir al escenario de línea base'
		}
	},
	fishbone_branch: {
		name: 'Hueso',
		name_plural: 'Huesos',
		fields: {
			completion: 'Finalización',
			trend: 'Estado',
			name: 'Nombre',
			description: 'Descripción',
			weight: 'Peso',
			responsible: 'Responsable',
			dates: 'Fechas',
			startOn: 'Inicio',
			endOn: 'Fin'
		},
		messages: {
			delete_confirmation: 'Eliminar rama del plan estratégico',
			delete_confirmation_explanation:
				'¿Estás seguro de que quieres eliminar esta rama? Esta acción no se puede deshacer y afectará a todos los escenarios.\n\nSi solo quieres ocultar la rama para este escenario, cierra esta ventana, selecciónala y en la columna derecha, haz clic en el botón "ojo" para desactivarla en este escenario.'
		},
		actions: {
			add: 'Agregar un hueso',
			clone: 'Clonar hueso',
			edit: 'Editar hueso',
			delete: 'Eliminar hueso'
		}
	},
	fishbone_item: {
		name: 'Sub-hueso',
		name_plural: 'Sub-huesos',
		fields: {
			name: 'Nombre',
			description: 'Descripción',
			completion: 'Finalización',
			trend: 'Estado',
			weight: 'Peso',
			responsible: 'Responsable',
			startOn: 'Inicio',
			endOn: 'Fin',
			dates: 'Fechas'
		},
		messages: {
			delete_confirmation: 'Eliminar sub-hueso',
			delete_confirmation_explanation:
				'¿Estás seguro de que quieres eliminar esta medida? Esta acción no se puede deshacer y afectará a todos los escenarios.\n\nSi solo quieres ocultar la medida para este escenario, cierra esta ventana, selecciónala y en la columna derecha, haz clic en el botón "ojo" para desactivarla en este escenario.'
		},
		actions: {
			add: 'Agregar un sub-hueso',
			clone: 'Clonar sub-hueso',
			edit: 'Editar sub-hueso',
			delete: 'Eliminar sub-hueso'
		}
	},
	risk: {
		name: 'Riesgo',
		name_plural: 'Riesgos',
		name_positive: 'Apertura',
		name_plural_positive: 'Aperturas',
		fields: {
			name: 'Nombre',
			description: 'Descripción - Indicadores de ocurrencia',
			reference: 'Referencia',
			risk_category: 'Categoría',
			likelihood: 'Probabilidad',
			likelihood_level: 'Nombre del nivel de probabilidad',
			impact: 'Impacto',
			impact_level: 'Nombre del nivel de impacto',
			matching_opportunity: 'Apertura',
			matching_risks: 'Riesgos',
			evaluated_at: 'Evaluación',
			exposure: 'Exposición',
			exposure_positive: 'Potencial',

			opportunity: {
				name: 'Apertura'
			}
		},
		messages: {
			delete_confirmation: 'Eliminar riesgo',
			delete_confirmation_explanation:
				'¿Estás seguro de que quieres eliminar este riesgo? Esta acción no se puede deshacer y afectará a todos los escenarios.\n\nSi solo quieres ocultar el riesgo para este escenario, cierra esta ventana, selecciónalo y en la columna derecha, haz clic en el botón "ojo" para desactivarlo en este escenario.',
			delete_opening: 'Eliminar apertura',
			delete_opening_explanation:
				'¿Estás seguro de que quieres eliminar esta apertura? Esta acción no se puede deshacer y afectará a todos los escenarios.\n\nSi solo quieres ocultar la apertura para este escenario, cierra esta ventana, selecciónala y en la columna derecha, haz clic en el botón "ojo" para desactivarla en este escenario.',
			no_x: 'Sin riesgo',
			no_category: 'Sin categoría',
			no_x_positive: 'Sin apertura'
		},
		impacts: {
			1: 'Insignificante',
			2: 'Menor',
			3: 'Moderado',
			4: 'Mayor',
			5: 'Extremo'
		},
		likelihoods: {
			1: 'Muy improbable',
			2: 'Improbable',
			3: 'Posible',
			4: 'Probable',
			5: 'Casi seguro'
		},
		actions: {
			create_new: 'Crear nuevo riesgo o apertura',
			edit: 'Editar riesgo',
			edit_opportunity: 'Editar apertura',
			delete: 'Eliminar riesgo',
			delete_opportunity: 'Eliminar apertura'
		}
	},
	risk_category: {
		name: 'Categoría',
		name_plural: 'Categorías',
		fields: {
			name: 'Nombre'
		},
		messages: {
			delete_confirmation: 'Eliminar categoría',
			delete_confirmation_explanation:
				'¿Estás seguro de que quieres eliminar esta categoría? Esta acción no se puede deshacer.',
			no_x: 'Sin categoría'
		},
		actions: {
			create_new: 'Crear una nueva categoría',
			edit: 'Editar categoría',
			delete: 'Eliminar categoría',
			add_x: 'Agregar una categoría'
		},
		default_values: {
			name: {
				1: 'Existencial',
				2: 'Estratégica',
				3: 'Operacional'
			}
		}
	},
	indicator_category: {
		name: 'Categoría',
		name_plural: 'Categorías',
		fields: {
			name: 'Nombre'
		},
		messages: {
			delete_confirmation: 'Eliminar categoría',
			delete_confirmation_explanation:
				'¿Estás seguro de que quieres eliminar esta categoría? Esta acción no se puede deshacer.',
			no_x: 'Sin categoría',
			unassigned: 'Sin asignar'
		},
		actions: {
			create_new: 'Crear una nueva categoría',
			edit: 'Editar categoría',
			delete: 'Eliminar categoría',
			add_x: 'Agregar una categoría'
		},
		default_values: {
			name: {
				1: 'Financiera',
				2: 'Clientes',
				3: 'Procesos internos',
				4: 'Aprendizaje y crecimiento'
			}
		}
	},
};
